import React from "react";
import { connect } from "react-redux";
import { aggregateID } from "lib/id";

import {
  getFilteredShopItemIDList,
  getSchoolByStudentID,
  getGoToShopItemID,
  getShopItemSearchQuery
} from "state/school_money/selectors";
import { clearGoToShopItem } from "state/school_money/actions";

import ScrollableList from "components/ScrollableList";
import Gate from "components/Gate";
import Card from "components/Card";
import PlaceholderCard from "components/school_money/PlaceholderCard";
import ShopItem from "components/school_money/shop/ShopItem";

class StudentShopItemList extends React.Component {

  static renderSearchPlaceholder() {
    return (
      <Card>
        <Card.Body>
          <div className="shop-item-list__placeholder">There are no shop items matching your search.</div>
        </Card.Body>
      </Card>
    );
  }

  render() {

    const { studentID, shopItemIDList, searchQuery, school } = this.props;
    const hasQuery = searchQuery !== "";

    const hasItems = shopItemIDList.size > 0;
    // use a custom placeholder if the search has returned no results
    const defaultPlaceholder = <PlaceholderCard school={school} objectName="shop items" />;
    const searchPlaceholder = StudentShopItemList.renderSearchPlaceholder();
    const placeholder = hasQuery ? searchPlaceholder : defaultPlaceholder;

    return (
      <ScrollableList className="shop-item-list" onScroll={this.props.clearGoTo} scrollTargetID={this.props.goToShopItemID}>
        { refChild => (
          <Gate isOpen={hasItems} placeholder={placeholder}>
            {
              shopItemIDList.map(shopItemID => (
                <ShopItem
                  key={shopItemID}
                  shopItemID={shopItemID}
                  studentID={studentID}
                  innerRef={child => refChild(child, aggregateID(studentID, shopItemID))}
                />
              ))
            }
          </Gate>
        ) }
      </ScrollableList>
    );

  }

}

export default connect(
  (state, { studentID, searchQuery }) => ({
    shopItemIDList: getFilteredShopItemIDList(state, studentID),
    school: getSchoolByStudentID(state, studentID),
    goToShopItemID: getGoToShopItemID(state),
    searchQuery: getShopItemSearchQuery(state)
  }),
  {
    clearGoTo: clearGoToShopItem
  }
)(StudentShopItemList);



// WEBPACK FOOTER //
// ./src/components/school_money/shop/StudentShopItemList.js